export default __webpack_public_path__ + "static/media/erc20.92241331.svg";